import type { Component } from 'vue';
import { ExternalLink } from 'lucide-vue-next';

// A partner names its icons in configuration (`icon?: string` on a footer link), so the names arrive
// at runtime: this map is what a bundler can see. Add an entry when a config introduces a name; an
// unknown one renders nothing, which every call site already handles.
const RESOLVABLE_ICONS: Record<string, Component> = {
  ExternalLink,
};

export const resolveLucideIcon = (iconName: string): Component | undefined => RESOLVABLE_ICONS[iconName];
